import React from "react";
import classNames from "classnames/bind";

import { ScreenInfo } from "../../components/ScreenInfo";
import { Footer } from "../../components/Footer";

import { UserType } from "types/UserType";

import styles from "./InvalidLink.module.css";

const cx = classNames.bind(styles);

type Props = {
  isLite?: boolean;
  userType: UserType;
};

const titleByType = {
  [UserType.LITE]:
    "Эта ссылка уже закончила действие или ваш консультант закрыл ее досрочно или выслал новую ссылку.",
  [UserType.PRO]:
    "Эта ссылка уже закончила действие или специалист закрыл ее досрочно или выслал новую ссылку.",
};
const textByType = {
  [UserType.LITE]:
    "Пожалуйста, попросите вашего консультанта выслать новую ссылку (либо перейдите по ней, если он уже сделал это).",
  [UserType.PRO]:
    "Попросите вашего специалиста выслать новую ссылку, либо перейдите по ней, если новая ссылка уже пришла.",
};

export const InvalidLink: React.FC<Props> = ({ userType }) => {
  return (
    <ScreenInfo title={titleByType[userType]}>
      <p className={cx("info")}>{textByType[userType]}</p>

      <Footer />
    </ScreenInfo>
  );
};
